module.exports = __webpack_public_path__ + "img/envelope2.4183d18d.png";